import fancybox from '@fancyapps/fancybox';

/**
 * Wallpaper Modal
 */


// console.log(fancybox);



// WEBPACK FOOTER //
// ./src/js/features/wallpaperModal.js